import React from 'react'
import "./ThirdSection.css"
import { Col, Container, Row } from 'react-bootstrap'
import greenBg from "../../Assets/images/bg-green.png"
import icon1 from "../../Assets/images/Group 1.png"
import icon2 from "../../Assets/images/Group 2.png"
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

function ThirdSection() {
  const { t, i18n } = useTranslation();

  return (
    <Container>
      <div className='third-section my-5'>
        <div className='why-kalemon my-5'>
          <h2> {t("why_choose_kalemon")} </h2>
        </div>

        <div id="carouselExampleIndicators1" className="carousel slide my-5" data-bs-ride="carousel" data-bs-interval="5000">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0"
              className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1"
              aria-label="Slide 2"></button>
          </div>

          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="row my-3 pb-5 gx-5 mx-5">
                <div className="col-lg-6 cursol-item-container">
                  <img src={greenBg} alt='' className='green-bg ' />
                  <div className='card-content'>
                    <h5 className='mt-3'>{t('digital_platform')}</h5>
                    <h3>{t('digital_platform_desc')}</h3>
                  </div>
                  <img src={icon1} alt='' className='icon-img ' />
                </div>
                <div className="col-lg-6 cursol-item-container">
                  <img src={greenBg} alt='' className='green-bg ' />
                  <div className='card-content'>
                    <h5 className='mt-3'>{t('expert_teachers')}</h5>
                    <h3>{t('certified_instructors')}</h3>
                  </div>
                  <img src={icon2} alt='' className='icon-img ' />
                </div>
              </div>
            </div>

            {/* Slide 2 (duplicate or can be changed) */}
            <div className="carousel-item active">
              <div className="row my-3 pb-5 gx-5 mx-5">
                <div className="col-lg-6 cursol-item-container">
                  <img src={greenBg} alt='' className='green-bg ' />
                  <div className='card-content'>
                    <h5 className='mt-3'>{t('Proven_Methodology')}</h5>
                    <h3>{t('structured_curriculum')}</h3>
                  </div>
                  <img src={icon1} alt='' className='icon-img ' />
                </div>
                <div className="col-lg-6 cursol-item-container">
                  <img src={greenBg} alt='' className='green-bg ' />
                  <div className='card-content'>
                    <h5 className='mt-3'>{t('expert_teachers')}</h5>
                    <h3>{t('certified_instructors')}</h3>
                  </div>
                  <img src={icon2} alt='' className='icon-img ' />
                </div>
              </div>
            </div>
          </div>

          {/* Controls */}
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">{t('testimonials.prev')}</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">{t('testimonials.next')}</span>
          </button>
        </div>
      </div>
      <div className='last-sec my-5 d-flex justify-content-center align-items-center w-100'>
        <Link to="/why-kalemon" onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); }}>
          <button > {t("discover_difference")} </button>
        </Link>
      </div>
    </Container>
  )
}

export default ThirdSection
